import { faArrowLeft, faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import styles from 'components/UI/V3/Pagination/Pagination.module.scss';
import { PaginationSize } from 'components/UI/V3/Pagination/Size/PaginationSize';
import { Spinner } from 'components/UI/V3/Spinner/Spinner';
import React from 'react';

export interface PaginationProps {
    page: number;
    totalPages: number;
    size?: number;
    isLoading?: boolean;
    onPageChange?: (page: number) => void;
    onSizeChange?: (size: number) => void;
    className?: string;
}

export const Pagination: React.FC<PaginationProps> = ({
    page,
    totalPages,
    size,
    isLoading,
    onPageChange,
    onSizeChange,
    className
}) => {
    const pageChangeHandler = React.useCallback(
        (page: number) => {
            if (page < 1 || page > totalPages) {
                return;
            }

            onPageChange?.(page);
        },
        [onPageChange, totalPages]
    );

    if (isLoading) {
        return (
            <div className={clsx(styles.root, className)}>
                <Spinner size={33} />
            </div>
        );
    }

    return (
        <div className={clsx(styles.root, className)}>
            {size && (
                <PaginationSize
                    size={size}
                    onChange={onSizeChange}
                />
            )}

            <div className={styles.pagination}>
                <span>
                    {page} of {totalPages}
                </span>

                {(page > 1 || page < totalPages) && (
                    <div className={styles.paginationControls}>
                        {page > 1 && (
                            <button
                                type="button"
                                onClick={() => pageChangeHandler(page - 1)}
                            >
                                <FontAwesomeIcon icon={faArrowLeft} />
                            </button>
                        )}
                        {page < totalPages && (
                            <button
                                type="button"
                                onClick={() => pageChangeHandler(page + 1)}
                            >
                                <FontAwesomeIcon icon={faArrowRight} />
                            </button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};
